import styled from '@emotion/styled';


export const Filters = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px 40px;

    width: 100%;
    max-width: 953px;
    min-height: 66px;

    align-items: flex-start;
    flex-wrap: wrap;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    width: 256px;
    min-height: 66px;
    gap: 10px;
`;

export const FilterDropdownMultiGroupSelectWrapper = styled.div`
  div[class*="option"] {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
  }
`;


export const FieldLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #555;

    display: flex;
    align-items: center;
    gap: 6px;

    width: 100%;

`;

export const SelectWrap = styled.div`
    position: relative;
    width: 100%;
`;

export const Select = styled.select`
    width: 100%;               
    height: 40px;               

    border-radius: 8px;
    border: 1px solid #d0d5dd;
    background: #fff;

    padding: 0 36px 0 12px;

    font-size: 14px;
    font-weight: 500;
    color: #111827;

    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: flex;
    align-items: center;

    outline: none;
    z-index: 2;

    &:focus {
        border-color: #94a3b8;
    }
`;

export const Chevron = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280;
`;
